(() => {
  if (window.mmNativeReviewsBound) return;
  window.mmNativeReviewsBound = true;
  const init = root => root.querySelectorAll('.mr').forEach(section => {
    if (section.dataset.ready) return;
    section.dataset.ready = 'true';
    const panel = section.querySelector('.mr-form-panel');
    const form = panel?.querySelector('form');
    section.querySelector('[data-mr-open]')?.addEventListener('click', () => { panel.open = true; });
    if (form) {
      const body = form.querySelector('textarea[name="comment[body]"]');
      const radios = [...form.querySelectorAll('[name="mr_rating"]')];
      const output = form.querySelector('output');
      const update = () => {
        const rating = Number(radios.find(r => r.checked)?.value || 0);
        radios.forEach(r => r.parentElement.classList.toggle('is-filled', Number(r.value) <= rating));
        if (output) output.textContent = rating ? `${rating} / 5` : 'Wybierz ocenę';
      };
      if (body) {
        const match = body.value.match(/^\[Ocena: ([1-5])\/5\]\s*/);
        if (match) { radios.find(r => r.value === match[1]).checked = true; body.value = body.value.slice(match[0].length); }
        const serialized = document.createElement('input');
        serialized.type = 'hidden';
        serialized.name = 'comment[body]';
        body.name = 'mr_review_text';
        body.insertAdjacentElement('afterend', serialized);
        const sync = () => {
          const rating = radios.find(r => r.checked)?.value;
          serialized.value = (rating ? `[Ocena: ${rating}/5]\n` : '') + body.value;
          update();
        };
        radios.forEach(r => r.addEventListener('change', sync));
        body.addEventListener('input', sync);
        form.addEventListener('submit', sync, true);
        sync();
      }
      if (form.querySelector('.mr-errors,.mr-success')) panel.open = true;
    }
    const track = section.querySelector('.mr-track');
    if (track) {
      const prev = section.querySelector('[data-mr-prev]');
      const next = section.querySelector('[data-mr-next]');
      const update = () => {
        const overflow = track.scrollWidth > track.clientWidth + 3;
        section.querySelector('.mr-arrows').hidden = !overflow;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 3;
      };
      const move = dir => track.scrollBy({left:dir * (track.querySelector('.mr-card').getBoundingClientRect().width + 18),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      prev.addEventListener('click', () => move(-1)); next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', update, {passive:true});
      const observer = new ResizeObserver(update); observer.observe(track); update();
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document)); else init(document);
  document.addEventListener('shopify:section:load', e => init(e.target.parentElement));
})();
